import { render, staticRenderFns } from "./DebugTool.vue?vue&type=template&id=0bfe6590"
import script from "./DebugTool.vue?vue&type=script&lang=js"
export * from "./DebugTool.vue?vue&type=script&lang=js"
import style0 from "./DebugTool.vue?vue&type=style&index=0&id=0bfe6590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports